import { createContext } from 'react';

import { useFeatureInit } from './use-feature-init';

type FeatureContext = ReturnType<typeof useFeatureInit>;
export const FeatureFlagContext = createContext<FeatureContext | undefined>(undefined);
FeatureFlagContext.displayName = 'FeatureFlagProvider';
